/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';

export default declareLinkedEntity({
    entity: "views",
    graphQL: "View",
    name: "Views",
    storageType: 'central',
    parentRelation: "views",
    defaultOrder: ['order'],
    isPublic: true,
    writePermissionFromParent: true,
    fields: (types) => { return {
        id: {
            name: "View ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: true,
            isPublic: true,
        },
        handler: {
            name: "Handler",
            type: "string",
            defaultValue: "",
            isPublic: true,
        },
        dataSource: {
            name: "Data Source",
            type: "relation",
            to: () => types['dataSources'],
            hiddenCreate: true,
            relativeTo: ['screen', 'screenDef', 'scenarioScreenDef', 'scenarioDef'],
            isPublic: true,
        },
        screen: {
            name: "Screen",
            type: "relation",
            to: () => types['screens'],
            parent: true, /* we are using multiple (variable) parents */
            compositeKey: true,
            hiddenCreate: true,
        },
        screenDef: {
            name: "Screen Definition",
            type: "relation",
            to: () => types['screenDefs'],
            parent: true, /* we are using multiple (variable) parents */
            compositeKey: true,
            hiddenCreate: true,
        },
        scenarioScreenDef: {
            name: "Screen Definition",
            type: "relation",
            to: () => types['scenarioScreenDefs'],
            parent: true, /* we are using multiple (variable) parents */
            compositeKey: true,
            hiddenCreate: true,
            relativeTo: ['scenarioDef'],
            isPublic: true,
        },
        scenarioDef: {
            name: "Screen Definition",
            type: "relation",
            to: () => types['scenarioDefs'],
            hiddenCreate: true,
            compositeKey: true,
            isPublic: true,
        },
        backendHandlers: {
            name: "Backend Handler",
            type: "object",
            defaultValue: [],
        },
        backendOptions: {
            name: "Backend Options",
            type: "object",
            defaultValue: {},
        },
        template: {
            name: "Template",
            type: "text",
            defaultValue: "",
			description: "There are some semantic class names: 'header' for header, 'data' to wrap all data elements, 'optional' for elements which may not be filled",
            isPublic: true,
        },
		filter: {
            name: "Filter",
            type: "object",
            defaultValue: {},
			description: "Filter object for data query",
            isPublic: true,
		},
		order: {
            name: "Order",
            type: "object",
            defaultValue: [],
			description: "Order of the data in the query",
            isPublic: true,
		},
        entityViewDef: {
            name: "Entity View Definition",
            type: "relation",
            to: () => types['entityViewDefs'],
            isPublic: true,
        },
        connectedChannel: {
            name: "Connected Application",
            description: "If this view needs some Application, this is the link",
            type: "relation",
            to: () => types['channels'],
        },
        connectedChannelDef: {
            name: "Connected Application Definition",
            description: "If this view needs some Application, this is the link to channelDef for later reconstruction",
            type: "relation",
            isPublic: true,
            to: () => types['channelDefs'],
        },
        connectedChannelDefKey: {
            name: "Connected Application Definition Key",
            type: "string",
        },
        channelAddon: {
            name: "Application Addon",
            type: "relation",
            to: () => types['channelAddons'],
            relativeTo: ['channelAddonChannel'],
        },
        channelAddonChannel: {
            name: "Application Addon Application",
            type: "relation",
            to: () => types['channels'],
        },
    }; },
    relations: (types) => { return {
    }; }
});
